import React, { forwardRef, useCallback, useEffect, useRef } from 'react';
import createClass from 'create-react-class';
import Select from './Select';

function reduce(obj, props = {}) {
  return Object.keys(obj).reduce((props, key) => {
    const value = obj[key];
    if (value !== undefined) props[key] = value;
    return props;
  }, props);
}

const AsyncCreatable = forwardRef((props, forwardedRef) => {
  const select = useRef();

  useEffect(() => {
    select.current?.focus?.();
  }, []);

  return (
    <Select.Async {...props} ref={forwardedRef}>
      {(asyncProps) => (
        <Select.Creatable {...props}>
          {(creatableProps) => (
            <Select
              {...reduce(asyncProps, reduce(creatableProps, {}))}
              onInputChange={(input) => {
                creatableProps.onInputChange(input);
                return asyncProps.onInputChange(input);
              }}
              ref={(ref) => {
                if ('current' in forwardedRef) {
                  forwardedRef.current = ref;
                } else {
                  forwardedRef?.(ref);
                }

                if (ref) select.current = ref;
                creatableProps.ref(ref);
                asyncProps.ref(ref);
              }}
            />
          )}
        </Select.Creatable>
      )}
    </Select.Async>
  );
});

AsyncCreatable.displayName = 'AsyncCreatableSelect';

export default AsyncCreatable;
